
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local';

// 强制使用英文
i18n
  .use(initReactI18next)
  .init({
    resources: messages,
    lng: 'en', // 强制使用英文
    fallbackLng: 'en', // 默认使用英文
    supportedLngs: ['en', 'zh'], // 支持的语言列表
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
